import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderCell from '@components/DataGrid/RenderCell';
import RenderHeader from '@components/DataGrid/RenderHeader';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceContainerStatusDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Cntr Status',
	minWidth: 130,
	width: 150,
	headerName: 'Trc Cntr Status',
	renderHeader: () => <RenderHeader primaryText='Trc Cntr Status' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.trcCntrStatus && (
					<span
						className={styles.bold}
						title={row.trcCntrStatus}
					>
						{row.trcCntrStatus}
					</span>
				)
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcCntrStatus } = row;
				return caseInsensitiveIncludes(value, [trcCntrStatus]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcCntrStatus ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceContainerStatusDefinition;
